// frontend/src/api/companyAPI.js
// Tenant-facing company endpoints, including the transparency views —
// what platform support access and activity has been logged against us.
import axios from 'axios';
import { API_BASE_URL, authHeader } from './axiosConfig';

const companyAPI = {
  // Public — no auth header, used from the signup page before login exists.
  checkEmail: (email) =>
    axios.get(`${API_BASE_URL}/company/check-email`, { params: { email } }).then(r => r.data),

  register: (data) =>
    axios.post(`${API_BASE_URL}/company/register`, data).then(r => r.data),

  getProfile: () =>
    axios.get(`${API_BASE_URL}/company/profile`, { headers: authHeader() }).then(r => r.data),

  updateProfile: (data) =>
    axios.put(`${API_BASE_URL}/company/profile`, data, { headers: authHeader() }).then(r => r.data),

  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return axios.post(`${API_BASE_URL}/company/upload-logo`, formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },

  uploadPdfTileImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return axios.post(`${API_BASE_URL}/company/upload-pdf-tile-image`, formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data);
  },

  getSupportAccessLog: () =>
    axios.get(`${API_BASE_URL}/company/support-access-log`, { headers: authHeader() }).then(r => r.data),

  getActivityLog: () =>
    axios.get(`${API_BASE_URL}/company/activity-log`, { headers: authHeader() }).then(r => r.data),
};

export default companyAPI;
